'use client';
import { Button } from '@benzinga/core-ui';
import { openWindow } from '@benzinga/frontend-utils';
import React from 'react';
import styles from './no-results.module.scss';
interface Props {
  hideSearchTips?: boolean;
  hideSupportButton?: boolean;
  message?: React.ReactNode;
  style?: React.CSSProperties;
}

export const NoResults: React.FC<Props> = ({ hideSearchTips, hideSupportButton, message, style }) => {
  const newIntercomWindow = () => {
    const url = 'https://pro.benzinga.com/helpchat/';
    const name = 'Benzinga Pro Help Chat';
    const options = 'width=425,height=550,left=0,resizable';
    openWindow(url, name, options, undefined, { free: true });
  };

  const handleChatSupportWindow = () => {
    if ((window as any).Intercom) {
      (window as any).Intercom('show');
    } else {
      console.debug('[NoResults] Intercom widget not loaded; opening help chat in a new window');
      newIntercomWindow();
    }
  };

  return (
    <div className={styles.noResultsContainer} style={style}>
      <div className={styles.title}>{message ?? 'No results found.'}</div>
      {!hideSearchTips && (
        <div className={styles.tips}>
          <div className={styles.header}>Search Tips:</div>
          <ul>
            <li>Make your search as concise as possible.</li>
            <li>Ensure words are spelled correctly.</li>
            <li>Try less specific keywords.</li>
          </ul>
        </div>
      )}
      {!hideSupportButton && (
        <Button className={styles.support} onClick={handleChatSupportWindow}>
          Chat With Support
        </Button>
      )}
    </div>
  );
};
